import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { BatchExportMapper } from '../mappers/BatchExportMapper';

export const QUERY_EXPORTS = `
query($reportId: ID!) {
  node(id: $reportId) {
    ... on ReportDone {
      exports {
        __typename
        exportType
        status
        totalCount
        exportedCount
        createdAt
        canceledAt
      }
    }
  }
}`;

export class BatchExportRepository extends BaseGQLService {
  private readonly mapper = new BatchExportMapper();

  async queryExports(reportId: number) {
    return this.mutate(
      QUERY_EXPORTS,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
      },
      (data) => {
        return this.mapper.mapExports(data.node.exports);
      }
    );
  }
}
